export enum CulturalActivityStatus {
    Overdue = "overdue",
    Upcoming = "upcoming",
}
